import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCOTC4reUy93ZjCvzFLx5mjzlotf_-JNvQ',
  authDomain: 'ppi-app-v2.firebaseapp.com',
  projectId: 'ppi-app-v2',
  storageBucket: 'ppi-app-v2.appspot.com',
  messagingSenderId: '1086913156640',
  appId: '1:1086913156640:web:e404bf56ec7eedc2080e45',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Set auth persistence to LOCAL so users stay logged in across browser sessions
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Failed to set auth persistence:', error);
});

export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
